import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  gross_method_rate: {
    name: 'Leverage under gross method',
    order: 294
  },
  commitment_method_rate: {
    name: 'Leverage under commitment method',
    order: 295
  }
};

export function Leverage({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.LEVERAGE_AIF,
    onChangeFund,
    schema: schema.LEVERAGE_AIF,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.LEVERAGE_AIF?.field_names || [],
    columnLables,
    tableName: 'LEVERAGE_AIF',
    funds,
    isMultiFunds
  });

  return (
    <Table
      id="reporttables-leverage-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
